import { useTranslation } from "i18n";
import {
  AlertMessage,
  IAlertMessageProps,
} from "../../Molecules/AlertMessage/AlertMessage";
import { Popup, IPopupProps } from "../../Molecules/Popup/Popup";

interface Props {
  handleClose: () => void;
}

export const AgenciesWithFilmmakersErrorPopUp = ({ handleClose }: Props) => {
  const { t } = useTranslation();

  const popupProps: IPopupProps = {
    width: { lg: 5, md: 6 },
    close: handleClose,
    priority: "high",
    texts: { closePopup: "" },
  };

  const alertProps: IAlertMessageProps = {
    icon: "notice",
    texts: {
      title: t("common:errorPopup.httpStatus.generic.title"),
      description: t("common:errorPopup.httpStatus.generic.body"),
    },
    buttons: [
      {
        name: t("common:button.label.close"),
        type: "primary",
        click: handleClose,
      },
    ],
  };

  return (
    <Popup {...popupProps}>
      <AlertMessage {...alertProps} />
    </Popup>
  );
};
